import rawBundle from "../../../../content/astra-content.json";
import type {
  AstraContentBundle,
  Community,
  CriterionId,
  Glossary,
  GuideData,
  SchoolContent,
} from "@/types/content";
import type { IdentityId, SchoolId } from "@/types/navigation";

const bundle = rawBundle as AstraContentBundle;

export function getGlossary(): Glossary {
  return bundle.glossary;
}

export function getSchool(schoolId: SchoolId): SchoolContent | undefined {
  return bundle.schools.find((s) => s.id === schoolId);
}

export type ResolvedGuide = GuideData & {
  school: SchoolContent;
  identityId: Exclude<IdentityId, "other">;
};

/**
 * §1用当前身份empathyText；若reuseGuideFrom === solo，§2–§5读solo数据。
 */
export function getGuide(
  schoolId: SchoolId,
  identityId: Exclude<IdentityId, "other">,
): ResolvedGuide | null {
  const school = getSchool(schoolId);
  if (!school) return null;

  const identity = school.identities.find((i) => i.id === identityId);
  if (!identity?.guide) return null;

  const soloGuide = school.identities.find((i) => i.id === "solo")?.guide;
  const g = identity.guide;

  if (g.reuseGuideFrom === "solo" && identityId !== "solo" && soloGuide) {
    return {
      school,
      identityId,
      empathyText: g.empathyText,
      reuseGuideFrom: g.reuseGuideFrom,
      overviewText: soloGuide.overviewText,
      overviewMap: soloGuide.overviewMap,
      regions: soloGuide.regions,
      communities: soloGuide.communities,
    };
  }

  return { school, identityId, ...g };
}

export function sortCommunities(
  communities: Community[],
  criterion: CriterionId | null,
): Community[] {
  if (!criterion) return [...communities];
  return [...communities].sort(
    (a, b) => b.priorityScores[criterion] - a.priorityScores[criterion],
  );
}

export function regionLabel(
  regions: GuideData["regions"],
  regionId: string,
): string {
  return regions.find((r) => r.id === regionId)?.nameCn ?? regionId;
}

export function regionLetter(index: number): string {
  return String.fromCharCode(65 + index);
}
